import React from 'react';

const InstagramIcon = ({
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "15",
    height: "16",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.35 0.5H10.65C13.05 0.5 15 2.45 15 4.85V11.15C15 12.3037 14.5417 13.4101 13.7259 14.2259C12.9101 15.0417 11.8037 15.5 10.65 15.5H4.35C1.95 15.5 0 13.55 0 11.15V4.85C0 3.69631 0.458302 2.58987 1.27409 1.77409C2.08987 0.958302 3.19631 0.5 4.35 0.5ZM4.2 2C3.48392 2 2.79716 2.28446 2.29081 2.79081C1.78446 3.29716 1.5 3.98392 1.5 4.7V11.3C1.5 12.7925 2.7075 14 4.2 14H10.8C11.5161 14 12.2028 13.7155 12.7092 13.2092C13.2155 12.7028 13.5 12.0161 13.5 11.3V4.7C13.5 3.2075 12.2925 2 10.8 2H4.2ZM11.4375 3.125C11.6861 3.125 11.9246 3.22377 12.1004 3.39959C12.2762 3.5754 12.375 3.81386 12.375 4.0625C12.375 4.31114 12.2762 4.5496 12.1004 4.72541C11.9246 4.90123 11.6861 5 11.4375 5C11.1889 5 10.9504 4.90123 10.7746 4.72541C10.5988 4.5496 10.5 4.31114 10.5 4.0625C10.5 3.81386 10.5988 3.5754 10.7746 3.39959C10.9504 3.22377 11.1889 3.125 11.4375 3.125ZM7.5 4.25C8.49456 4.25 9.44839 4.64509 10.1517 5.34835C10.8549 6.05161 11.25 7.00544 11.25 8C11.25 8.99456 10.8549 9.94839 10.1517 10.6517C9.44839 11.3549 8.49456 11.75 7.5 11.75C6.50544 11.75 5.55161 11.3549 4.84835 10.6517C4.14509 9.94839 3.75 8.99456 3.75 8C3.75 7.00544 4.14509 6.05161 4.84835 5.34835C5.55161 4.64509 6.50544 4.25 7.5 4.25ZM7.5 5.75C6.90326 5.75 6.33097 5.98705 5.90901 6.40901C5.48705 6.83097 5.25 7.40326 5.25 8C5.25 8.59674 5.48705 9.16903 5.90901 9.59099C6.33097 10.0129 6.90326 10.25 7.5 10.25C8.09674 10.25 8.66903 10.0129 9.09099 9.59099C9.51295 9.16903 9.75 8.59674 9.75 8C9.75 7.40326 9.51295 6.83097 9.09099 6.40901C8.66903 5.98705 8.09674 5.75 7.5 5.75Z",
      fill: "white"
    }
  )
);

export { InstagramIcon };
//# sourceMappingURL=InstagramIcon.js.map
